import React, {useRef, useState} from 'react';
import {ListGroup, Popover, Overlay} from "react-bootstrap";

import './OverflowMenu.css';

const OverflowMenu = ({children}) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  return <div className="overflow-menu" ref={ref} onClick={handleClick}>
    <img className="overflow-icon" src="/assets/icons/menu.svg" height={12} />
    <Overlay
      show={show}
      target={target}
      placement="right"
      container={ref}
      containerPadding={20}
      rootClose={true}
      onHide={() => setShow(false)}
    >
      <Popover id="popover-contained">
        <ListGroup variant="flush">
          {children}
        </ListGroup>
      </Popover>
    </Overlay>
  </div>;
}

export default OverflowMenu;